import React, { useContext } from 'react'
import { directoryStrings } from '../directory/directory_i18n_mappings'
import { useTranslation } from 'react-i18next'
import { DashFrame, StyledAapnLink } from './partner_comparison_details.styles'
import { StyledPartnerComparisonCard, StyledSkeleton } from './components/partner_comparison_card/partner_comparison_card.styles'
import { ComparedPartnersContext } from '../directory/components/partner_comparison/compared_partners_context'
import { clickPartnerComparisonDetailsMetricHandler } from '../../util/partner_comparison_metrics_helper'
import { EmptyCtaText } from '../directory/components/partner_comparison/empty_compare_container.styles'
import { SEARCH_AND_FILTERS_SESSION_KEY } from '../../shared/constants'

export const EmptyPartnerComparisonCard: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation()
  const { loading } = useContext(ComparedPartnersContext)

  return (
    <StyledPartnerComparisonCard data-testid={'empty-partner-comparison-card'}>
      {loading ? (
        <StyledSkeleton count={7} />
      ) : (
        <StyledAapnLink
          to={`${sessionStorage.getItem(SEARCH_AND_FILTERS_SESSION_KEY) || ''}`}
          onClick={() => clickPartnerComparisonDetailsMetricHandler('partnerComparison.page.add.click')}
        >
          <DashFrame>
            <EmptyCtaText fontSize={'medium'}>{t(directoryStrings.SELECT_ANOTHER_PARTNER_TO_COMPARE)}</EmptyCtaText>
          </DashFrame>
        </StyledAapnLink>
      )}
    </StyledPartnerComparisonCard>
  )
}
